import { render, staticRenderFns } from "./testVue.vue?vue&type=template&id=276d9037&scoped=true"
import script from "./testVue.vue?vue&type=script&lang=js"
export * from "./testVue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276d9037",
  null
  
)

export default component.exports